import angular from 'angular';

import component from './venue-hours-phone-preview.component';

const VenueHoursPhonePreview = angular
    .module('control-room.venue-hours.components.venue-hours-phone-preview', [])
    .component('crVenueHoursPhonePreview', component);

export default VenueHoursPhonePreview;
